/**
 * Compare — 인증 전·후 비교표 (new design)
 *
 * preview/index.html 의 .compare 1:1 매칭
 *  - 3컬럼 그리드 (항목 / 인증 전 / 인증 후)
 *  - 모바일에서는 label을 한 행 위에 올리고 before/after는 2컬럼
 *  - after 셀에 <strong>이 들어가 있어서 dangerouslySetInnerHTML 사용
 *    (상수에서 하드코딩된 마크업이라 안전)
 *
 * 데이터: COMPARE_ROWS, COMPARE_NOTICE (config/constants.ts)
 */
import { COMPARE_ROWS, COMPARE_NOTICE } from '@/config/constants';

export function Compare() {
  return (
    <section className="compare">
      <div className="section-head">
        <span className="section-tag">BEFORE / AFTER</span>
        <h2 className="section-title">
          <span className="accent">인증 전·후</span><br />
          한눈에 비교해보세요
        </h2>
        <p className="section-sub">인증 취득 시 적용 가능한 주요 변화를 정리했습니다.</p>
      </div>

      <div className="compare-inner">
        <div className="compare-table" role="table">
          <div className="compare-row head" role="row">
            <div className="compare-cell label" role="columnheader">항목</div>
            <div className="compare-cell" role="columnheader">인증 전</div>
            <div className="compare-cell" role="columnheader">인증 후</div>
          </div>

          {COMPARE_ROWS.map((row) => (
            <div key={row.label} className="compare-row" role="row">
              <div className="compare-cell label" role="cell">{row.label}</div>
              <div className="compare-cell before" role="cell">{row.before}</div>
              <div
                className="compare-cell after"
                role="cell"
                dangerouslySetInnerHTML={{ __html: row.after }}
              />
            </div>
          ))}
        </div>

        <p className="compare-notice">{COMPARE_NOTICE}</p>
      </div>
    </section>
  );
}
